__turbopack_context__.v({
  "article": "ArticlePreview-module-scss-module__6K2wfW__article",
  "article__meta": "ArticlePreview-module-scss-module__6K2wfW__article__meta",
  "wrapper": "ArticlePreview-module-scss-module__6K2wfW__wrapper",
});
